import { useMemo, useState, useContext } from "react"
import { UserContext } from "../../store/store"

import { limits } from "../../services/statics"
import useFetch from "../../hooks/useFetch"
import { api } from "../../services/api"
import { Paginator } from "../../components/ui/Paginator"

import { ModalEliminarSugg } from "../../components/admin/ModalEliminarSugerencia"
import { config } from "../../config"
import { useTranslation } from "react-i18next"
import { getCookie } from "../../helpers/cookies"

export const GestionarSugerencias = () => {
  const { t } = useTranslation()

  // state
  const [limit, setLimit] = useState(config.default_limit),
    [offest, setOffset] = useState(1)

  // edit/delete word

  const [selected, setSelected] = useState(null),
    modalEliminar = useState(false)

  const onClickEliminar = (entry, e) => {
    e.preventDefault()
    setSelected(entry)
    modalEliminar[1](true)
  }

  const tkn = getCookie("jwt")

  const { url, opt } = useMemo(
    () =>
      api.suggestions.readAll({
        token: tkn,
        from: offest,
        limit,
      }),
    [tkn, limit, offest]
  )
  const [data, isPending, err, setData] = useFetch({ url, opt })

  const ListSuggestions = (suggs) => {
    const [state] = useContext(UserContext)
    const theme = state.theme === "light" ? "table-striped" : "table-dark"

    return (
      <table className={"table table-hover w-100 " + theme}>
        <thead>
          <tr>
            <th>ID</th>
            <th>{t(`ui.tables.date`)}</th>
            <th>{t(`admin.system.suggestion`)}</th>
            <th>
              <center>{t(`ui.tables.delete`)}</center>
            </th>
          </tr>
        </thead>
        <tbody style={{ borderTop: "2px solid #4e4e4e" }}>
          {suggs.map((sugg, ix) => (
            <tr key={ix}>
              <td>{sugg.id}</td>
              <td>{sugg.timestamp.slice(0, 10)}</td>
              <td style={{ width: "70%" }}>
                <pre
                  className="mb-0"
                  style={{
                    whiteSpace: "pre-wrap",
                    wordWrap: "break-word",
                  }}
                >
                  {sugg.text}
                </pre>
              </td>
              <td>
                <center>
                  <button
                    type="button"
                    onClick={onClickEliminar.bind(this, sugg)}
                    className="btn btn-sm tooltip elim-tooltip"
                  >
                    ❌
                  </button>
                </center>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }

  return (
    <>
      {modalEliminar[0] && (
        <ModalEliminarSugg
          show={modalEliminar}
          entry={selected}
          setEntries={setData}
        />
      )}

      <div className="col-12" style={{ margin: "0 auto" }}>
        <h4>{t(`admin.system.manage_suggestions`)}</h4>

        <div className="d-flex justify-content-end align-items-center flex-row pb-3">
          <div className="form-check">
            <label className="form-check-label">
              {t(`ui.tables.limit`)}
              <select
                className="form-select mini-select mx-2"
                value={limit}
                onChange={(e) => setLimit(parseInt(e.target.value))}
                style={{ fontSize: "14px" }}
              >
                {limits.map((lim, ix) => (
                  <option key={ix} value={lim}>
                    {lim}
                  </option>
                ))}
              </select>
            </label>
          </div>
        </div>

        {isPending && <p className="my-3">{t(`ui.btns.loading`)}...</p>}
        {err && <p className="my-3">{t(`ui.msgs.something_went_wrong`)}</p>}
        {!isPending && data && ListSuggestions(data.entries)}

        {!isPending && !err && (
          <Paginator
            total={data.total}
            offset={offest}
            radius={9}
            setOffset={setOffset}
            pageSize={limit}
          />
        )}
      </div>
    </>
  )
}
